import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, CreditCard } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { oapi } from '@/lib/officialsApi';
import { CheckoutDialog } from '@/components/billing/CheckoutDialog';

// Opens checkout for the yearly Officials add-on (any plan, incl. Free): card via Plug'n Pay or PayPal.
export const AddonSubscribeButton = ({ label, className = '', testId = 'addon-subscribe-btn' }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const start = () => {
    if (isLoading) return;
    if (!isAuthenticated) { navigate('/login?mode=register&redirect=%2Fofficials'); return; }
    setOpen(true);
  };

  const payWithPayPal = async () => {
    setBusy(true);
    try {
      const r = await oapi('/officials/billing/subscribe', { method: 'POST', body: {} });
      if (!r.approval_url) throw new Error('PayPal did not return a checkout link');
      window.location.href = r.approval_url;
    } catch (e) {
      toast.error(e.message);
      setBusy(false);
    }
  };

  return (
    <>
      <Button onClick={start} disabled={busy} data-testid={testId}
        className={`bg-amber-400 hover:bg-amber-300 text-[#00247D] font-bold transition-transform active:scale-[0.98] ${className}`}>
        {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CreditCard className="w-4 h-4 mr-2" />}
        {label || 'Subscribe'}
      </Button>
      <CheckoutDialog open={open} productId="officials_annual" onClose={() => setOpen(false)} onPayPal={payWithPayPal} />
    </>
  );
};
